module.exports = __webpack_public_path__ + "static/media/speech.a9b5fea3.png";